import { render, staticRenderFns } from "./method-selector.vue?vue&type=template&id=542c7642"
import script from "./method-selector.vue?vue&type=script&lang=js"
export * from "./method-selector.vue?vue&type=script&lang=js"
import style0 from "./method-selector.vue?vue&type=style&index=0&id=542c7642&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports